import Slider from 'components/3catinfo/Slider';
import Destacat from 'components/3catinfo/Destacat';
import styles from './tiraVideos.module.scss';

const TiraVideos = (props) => {
    const { items, titol, format = 'destacatVideo' } = props;
    const filteredItems = items.filter((item) => !item.programa?.toLowerCase().includes('reels'));
    return (
        <>
            {filteredItems.length > 0 && (
                <div className={styles.tiraVideos}>
                    <Slider titol={titol} format={format} estil='tiraVideos' estilModul='modulTiraVideos' fletxes='mig'>
                        {filteredItems.map((item) => (
                            <Destacat
                                key={`destacat-video-${item.id}`}
                                item={item}
                                routePath='web_3cat_item_video'
                                enllacExtern3Cat={true}
                                estil='box-0'
                            />
                        ))}
                    </Slider>
                </div>
            )}
        </>
    );
};

export default TiraVideos;
